import { render, staticRenderFns } from "./AscAircraftDetailsWrapper.vue?vue&type=template&id=64f96620&scoped=true&"
import script from "./AscAircraftDetailsWrapper.vue?vue&type=script&lang=js&"
export * from "./AscAircraftDetailsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscAircraftDetailsWrapper.vue?vue&type=style&index=0&id=64f96620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f96620",
  null
  
)

export default component.exports